<!-- ----------------------------------------------- -->
<template>
  <nav id="mbHeader" class="primary">
    <v-navigation-drawer
      v-model="drawer"
      :clipped="false"
      app
      temporary
      right
      width="280"
    >
      <v-subheader>{{ text.menu }}</v-subheader>
      <v-list-item dense @click="openInfoList">
        <v-list-item-icon>
          <v-icon>announcement</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ text.infolist }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item dense @click="openSrchDlg" v-if="!isReduction">
        <v-list-item-icon>
          <v-icon>search</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ text.search }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item dense @click="openManual">
        <v-list-item-icon>
          <v-icon>headset_mic</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ text.manual }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item dense @click="openGlossary">
        <v-list-item-icon>
          <v-icon>import_contacts</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ text.glossary }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item dense @click="openLinkList">
        <v-list-item-icon>
          <v-icon>insert_link</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ text.link }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item dense @click="openScreenManual">
        <v-list-item-icon>
          <v-icon>mdi-monitor-screenshot</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ text.screenManual }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item dense @click="openSiteMap">
        <v-list-item-icon>
          <v-icon>web</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ text.sitemap }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item dense @click="openInquiry" v-if="!getModeTest">
        <v-list-item-icon>
          <v-icon>email</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ text.inquiry }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item dense @click="openCaution">
        <v-list-item-icon>
          <v-icon>playlist_add_check</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ text.caution }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-subheader>{{ text.switching }}</v-subheader>
      <v-list-item dense @click="openViewConfig">
        <v-list-item-icon>
          <v-icon>build</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ text.settings }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <div class="frics-box ma-4">
        <v-spacer></v-spacer>
        <div class="menu-frics text-right mb-2">
          <span class="font-weight-bold grey--text text--darken-1"
            >Compiled by FRICS</span
          >
        </div>
      </div>
    </v-navigation-drawer>
    <v-row class="mb-app-bar-frame mx-0">
      <img
        class="title-pic"
        :src="getTitleImg"
        style="cursor: pointer;"
        @click="openPortal"
        v-if="!getModeTest"
      />
      <v-spacer></v-spacer>
      <div class="disp-time">
        <v-row class="mx-0" justify="end">
          <span :class="isCurrent ? 'text-date' : 'text-date-history'">
            {{ appDate }}
          </span>
        </v-row>
        <v-row class="mx-0" justify="end">
          <span :class="isCurrent ? 'text-time' : 'text-time-history'">
            {{ appTime }}
            <span v-if="!isCurrent" class="text-time-history-string">
              {{ text.historyMode }}
            </span>
          </span>
        </v-row>
      </div>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            @click="renew"
            class="mr-4"
            :disabled="disableUpdate"
            v-on="on"
          >
            <v-icon :color="isCurrent ? 'white' : 'brown lighten-3'">
              {{ updateIcon }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ text.update }}</span>
      </v-tooltip>
      <v-btn icon small @click="drawer = !drawer" class="mr-4">
        <v-icon color="white">menu</v-icon>
      </v-btn>
      <app-guide-dlg v-if="showGuide" @close="closeManual"></app-guide-dlg>
      <tm-search v-show="showSrchDlg"></tm-search>
    </v-row>
  </nav>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 モバイル用ヘッダ
 * Header.vue
 * @author LIS
 */
import mixin from "../../lib/mixin.js";
import Util from "../../lib/util.js";
import PageLog from "../../lib/pageLog.js";
import appGuideDlg from "../../components/mb/AppGuideDlg";
import tmSearch from "../mb/dlgs/TmSearch";

export default {
  /** タグ名 */
  name: "kwb-mb-header",
  mixins: [mixin],
  components: {
    appGuideDlg,
    tmSearch,
  },
  data() {
    return {
      /** 文字列リソース */
      text: {
        menu: "メニュー",
        infolist: "お知らせ",
        search: "観測所検索",
        glossary: "防災用語ウェブサイト",
        link: "リンク集",
        events: "イベント情報",
        manual: "操作説明",
        screenManual: "画面解説書",
        sitemap: "サイトマップ（トップページ）",
        inquiry: "お問い合わせ",
        caution: "ご利用上の注意事項",
        switching: "表示切替",
        settings: "表示設定",
        compiled: "Compiled by FRICS",
        update: "画面更新",
        historyMode: "(過去)",
      },
      drawer: null,
      showGuide: false,
    };
  },
  computed: {
    /** ベースとなる観測日時 */
    baseTime: {
      get() {
        let returnTime = this.$store.state.app.appTime;
        if (this.isCurrent) {
          if (this.$store.state.radar.radarType == "xrain") {
            returnTime = this.$store.state.radar.radarXrainDate;
          } else {
            returnTime = this.$store.state.radar.radarCbandDate;
          }
        }
        return returnTime;
      },
    },
    /** 観測日 */
    appDate() {
      return Util.formatDate24(this.baseTime, "YYYY/MM/DD");
    },
    /** 観測時間 */
    appTime() {
      return Util.formatDate24(this.baseTime, "HH:mm");
    },
    /** 履歴表示 */
    isCurrent() {
      return this.$store.state.app.isCurrent;
    },
    /** 表示コンテンツ取得 */
    getContent() {
      return this.$store.state.app.content;
    },
    /** 履歴表示有無によりアイコンを判断する */
    updateIcon() {
      if (this.$store.state.app.isCurrent) {
        return "autorenew";
      }
      return "update";
    },
    /** 更新ボタンの活性/非活性を制御する */
    disableUpdate() {
      // 履歴動画再生状態による制御
      if (!this.$store.getters["radar/isNotPlay"] || !this.$store.getters["Telemeter/isNotPlayMb"]) {
        return true;
      }

      // 表示コンテンツによる制御
      if (
        this.getContent == "Inundation" ||
        this.getContent == "VcPoint" ||
        this.getContent == "VcDefault" ||
        this.getContent == "VcCustom" ||
        this.getContent == "info"
      ) {
        return true;
      }
      return false;
    },
    /** URL */
    urls: {
      get() {
        return this.$store.state.app.config.appConfig.linkUrls;
      },
    },
    /** タイトル画像のPath */
    getTitleImg: {
      get() {
        let titlePath = "/kawabou/img/apptitle_gen.png";
        if (global.KWB_MODE === "admin") {
          titlePath = "/kawabou/img/apptitle_adm.png";
        }
        return titlePath;
      },
    },
    /** テストモード起動 */
    getModeTest: {
      get() {
        return global.TEST_MODE === "test";
      },
    },
    showSrchDlg: {
      get() {
        return this.$store.state.search.showSrchDlg;
      },
    },
    /** 簡易版判定  */
    isReduction: {
      get() {
        return global.KWB_MODE == "reduction";
      },
    },
  },
  methods: {
    /** 観測日時更新 */
    renew() {
      // アクセスログ出力
      PageLog.log({
        page_log: "map",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      // レーダの履歴動画再生状態をリセット
      this.$store.commit("radar/resetHistoryPlay");
      // 過去画像動画状態をリセット
      this.$store.commit("Telemeter/resetHistoryPlay");
      this.$store.commit("Telemeter/resetHistoryPrintCurrentPicture");
      // ストアの観測日時更新
      this.$store.commit("app/renewTime");
      // 観測日時クエリパラメーターを削除
      this.replaceTmQuery();
      // 画面遷移時の保持日時を更新
      this.$store.commit("app/setRetentionTime", {
        flag: true,
      });
    },
    /** タイトル画像選択 */
    openPortal() {
      window.location = this.urls.portalmb;
    },
    /** お知らせ詳細画面表示 */
    openInfoList() {
      let param = {
        infKnd: null,
        area: null,
        trgt: null,
        dvs: [],
      };
      this.routerPushMbInfoList("/mb/info", param);
      this.drawer = !this.drawer;
    },
    /** 観測所検索ダイアログ表示 */
    openSrchDlg() {
      this.$store.commit(
        "search/setShowSrchDlg",
        !this.$store.state.search.showSrchDlg
      );
      this.drawer = !this.drawer;
    },
    /** 用語集 */
    openGlossary() {
      // アクセスログ出力
      PageLog.log({
        page_log: "glossary",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.drawer = !this.drawer;
      window.open(this.urls.glossary, "_blank");
    },
    /** リンク集 */
    openLinkList() {
      // アクセスログ出力
      PageLog.log({
        page_log: "book",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.drawer = !this.drawer;
      window.open(this.urls.linklist, "_self");
    },
    /** イベント */
    openEvent() {
      // アクセスログ出力
      PageLog.log({
        page_log: "ivent",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.drawer = !this.drawer;
      window.open(this.urls.event, "_self");
    },
    /** 操作説明 */
    openManual() {
      // アクセスログ出力
      PageLog.log({
        page_log: "manual",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.drawer = !this.drawer;
      this.showGuide = true;
    },
    closeManual() {
      this.showGuide = false;
    },
    /** 画面解説書 */
    openScreenManual() {
      // アクセスログ出力
      PageLog.log({
        page_log: "screendescrip",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.drawer = !this.drawer;
      window.open(this.urls.manual, "_self");
    },
    /** サイトマップ */
    openSiteMap() {
      this.drawer = !this.drawer;
      window.open(this.urls.sitemap, "_self");
    },
    /** お問い合わせ */
    openInquiry() {
      this.drawer = !this.drawer;
      window.open(this.urls.inquiry, "_blank");
    },
    /** ご利用上の注意事項 */
    openCaution() {
      // アクセスログ出力
      PageLog.log({
        page_log: "notes",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.drawer = !this.drawer;
      window.open(this.urls.caution, "_self");
    },
    /** 表示設定表示 */
    openViewConfig() {
      this.drawer = !this.drawer;
      this.routerPush("/mb/vc");
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/kwb.scss";
#mbHeader {
  display: block;
  height: 42px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  z-index: 3070;
}
.mb-app-bar-frame {
  align-items: center;
  height: 100%;
  color: #fff;
  img {
    height: 100%;
    max-height: 36px;
  }
  .disp-time {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin-right: 16px;
  }
}
.text-date {
  font-size: 0.7rem;
  color: $color-header-text;
}
.text-date-history {
  font-size: 0.7rem;
  color: $color-header-text-history;
}
.text-time {
  font-size: 0.9rem;
  color: $color-header-text;
  font-weight: bold;
}
.text-time-history {
  font-size: 0.9rem;
  color: $color-header-text-history;
  font-weight: bold;
}
.text-time-history-string {
  font-size: 0.6rem;
  color: $color-header-text-history;
  font-weight: bold;
  vertical-align: 1px;
}
.menu-frics {
  letter-spacing: 0.03em;
  font-size: 0.7em;
}
.frics-box {
  min-height: calc(100% - 568px);
  display: flex;
  align-items: flex-end;
}
</style>
